<template>
  <a
    class="d-back-button button"
    :class="buttonClass"
    title="Back"
    @click="goBack()"
  >
    <DuiIconArrowLeft :class="vm.iconClass" />
  </a>
</template>

<script>
import Window from '@d-shared/utils/window';

export default {
  props: {
    backHandler: {
      type: Function,
      default: null,
    },
    buttonClass: {
      type: String,
      default: 'button-translucent',
    },
    defaultBackUrl: {
      type: String,
      default: null,
    },
    rootUrl: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    vm: {
      canGoBack: false,
      iconClass: '',
    },
  }),
  watch: {
    buttonClass: function() {
      this.setIconClass();
    },
  },
  mounted() {
    this.setBackUrl();
    this.setIconClass();
  },
  methods: {
    goBack() {
      if (this.backHandler) {
        this.backHandler();
        return;
      }

      if (this.vm.canGoBack) {
        Window.goBack();
        return;
      }

      const backUrl = this.defaultBackUrl ? this.defaultBackUrl : this.rootUrl;
      Window.goTo(backUrl);
    },

    setBackUrl() {
      const isComingFromDiscovery = Window.getReferrer().startsWith(this.rootUrl);
      this.$set(this.vm, 'canGoBack', isComingFromDiscovery);
    },

    setIconClass() {
      let iconClasses = [];

      if (this.buttonClass.includes('button-lg')) {
        iconClasses.push('icon-lg');
      }

      if (!this.buttonClass.includes('button-grey') &&
        !this.buttonClass.includes('button-white')) {
        iconClasses.push('icon-white');
      }

      this.$set(this.vm, 'iconClass', iconClasses.join(' '));
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.d-back-button {
  border-radius: 50%;
  display: inline-block;
  height: $_5em;
  position: relative;
  width: $_5em;

  .dui-icon {
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate3d(-50%, -50%, 0);
    z-index: 1;
  }
}
</style>
